module.exports = __webpack_public_path__ + "img/logo.4fe74d4d.svg";